/**
 * T.H.E Apps Studio - Curated High-Fidelity Assets
 * Reliable, production-ready photographic assets that render consistently
 * across all environments and production deployments (Vercel, custom domains, etc.)
 */

// Go Dutch: Group of friends enjoying a meal and drinks at an upscale restaurant
export const GO_DUTCH_HERO = "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=1200&auto=format&fit=crop";

// TeeMates: Golfers on a lush green fairway with morning sunlight
export const TEEMATES_HERO = "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?q=80&w=1200&auto=format&fit=crop";

// 3D Print Forge: Professional 3D printing in action with precision extruder
export const PRINT_FORGE_HERO = "https://images.unsplash.com/photo-1581092160607-ee22621dd758?q=80&w=1200&auto=format&fit=crop";

// Lyric Scroller: Concert stage performance with microphone, lighting, and stage monitors
export const LYRIC_SCROLLER_HERO = "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?q=80&w=1200&auto=format&fit=crop";

// WhistleRoll (School Sports Attendance & Tracking): School athletic field, coach and student athlete attendance
export const WHISTLEROLL_HERO = "https://images.unsplash.com/photo-1526232761682-d26e03ac148e?q=80&w=1200&auto=format&fit=crop";

// Vamosly: Padel tournament and league matches on glass-walled court
export const VAMOSLY_HERO = "https://images.unsplash.com/photo-1622163642998-1ea32b0bbc67?q=80&w=1200&auto=format&fit=crop";
